import { ISchoolModel, ISchoolSummaryModel } from "../../facilitator/models/ISchoolModel";

export interface ISharedFileComponentProps {
    eabhyasFilesShare: boolean;
    eabhyasFilesAdd: boolean;
    eabhyasFilesDelete: boolean;

    schoolFilesAdd: boolean;
    schoolFilesDelete: boolean;

    notificationFilesAdd: boolean;
    notificationFilesDelete: boolean;

    schoolSwitch: boolean;
}

export interface IEAbhyasSharedFileComponentProps {
    eabhyasFilesShare: boolean;
    eabhyasFilesAdd: boolean;
    eabhyasFilesDelete: boolean;

    schoolFilesAdd: boolean;
    schoolFilesDelete: boolean;

    notificationFilesAdd: boolean;
    notificationFilesDelete: boolean;

    schools: ISchoolSummaryModel[];
    selectedSchoolId: number | undefined;
}

export interface ISchoolSharedFileComponentProps {
    eabhyasFilesShare: boolean;
    eabhyasFilesAdd: boolean;
    eabhyasFilesDelete: boolean;

    schoolFilesAdd: boolean;
    schoolFilesDelete: boolean;

    notificationFilesAdd: boolean;
    notificationFilesDelete: boolean;

    selectedSchoolId: number | undefined;
}


export interface ISharedFile {
    fileId: number;

    fileName: string;

    filePath: string;

    uploadName: string;

    uploadedBy: string;

    uploadedOn: Date;

    isDeleteInProgress: boolean;

    schoolSharings: ISchoolFileSharing[]
}

export interface ISchoolFileSharing {
    schoolUserId: number;

    schoolName: string;

    sharedDate: Date;
}
export interface ISharedFileUploadRequest {
    purpose: number;
}
export interface ISharedFileDeleteRequest {
    schoolFileId: number;
}
export interface IShareFileShareRequest {
    schoolFileId: number;
    schoolIds: number[];
}

export interface IShareFileShareComponentProps {
    schoolFile: ISharedFile;
    isShareInProgress: boolean;
    handleClose: () => void;
    updateSchoolFileShare: (schoolFile: ISharedFile, schools: ISchoolSummaryModel[]) => void;

}

export const SharedFilePurpose = {
    EAbhyasFiles: 1,
    SchoolFiles: 2,
    NotificationFiles: 3
}